export default __webpack_public_path__ + "static/media/bg-photo.9a008cb4.png";